import moment from 'moment';

const isValidDate = (d) => d instanceof Date && !Number.isNaN(d);

export const millisecondsToDateString = (ms: string): string | null => {
  const intMs = parseInt(ms, 10) / 1000;
  try {
    return moment.unix(intMs).format('DD.MM.YYYY');
  } catch (e) {
    return null;
  }
};

export const millisecondsToDate = (ms: string): Date | null => {
  const intMs = parseInt(ms, 10);
  try {
    const date = new Date(intMs);
    if (isValidDate(date)) {
      return date;
    }
  } catch (e) {
    return null;
  }
  return null;
};
